import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../../modules/order-details';
import { UserRoleInput } from '../../states/user-role-state';
import { ensureAuthenticated } from '../../utilities/is-authenticated';

/**
 * GetUserRoles Input Action
 */
export class GetUserRolesInput implements Msdyn365.IActionInput {
    public userToken: string;

    constructor(ctx: Msdyn365.ICreateActionContext) {
        this.userToken = ctx.requestContext.user.token;
    }

    public getCacheKey = () => `GetUserRoles-${this.userToken}`;
    public getCacheObjectType = () => 'GetUserRoles';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetUserRolesResponse {
    value: string[];
    error?: ErrorCode;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetUserRolesInput(args);
};

async function action(_: GetUserRolesInput, ctx: Msdyn365.IActionContext): Promise<IGetUserRolesResponse | null> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetUserRolesResponse>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetUserRoles`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    ctx.update(new UserRoleInput(), { userRoles: response.data.value });

    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetUserRolesResponse>>action,
    id: 'GetUserRoles',
    input: createInput
});
